import { Stack } from '@mui/material'
import FormInput from 'components/form-elements/FormInput'
import FormMultipleSelect from 'components/form-elements/FormMultipleSelect'
import FormSelect from 'components/form-elements/FormSelect'
import { useCharactersLeft } from 'hooks/useCharactersLeft'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import {
  MAX_COMMENTS_LENGTH,
  ShareMemberOption,
  ShareType,
  shareTypeOptions,
} from '../../models/shareForm'

interface Props {
  options: ShareMemberOption[]
}

/**
 * Share controls (recipient type, members, comment) rendered inside a parent
 * `FormProvider`. Reused by `ArticleShareForm` and the shared-note create flow.
 * Expects the parent form to expose `type`, `members` and `comments` fields.
 */
export function ShareFields({ options }: Props) {
  const { watch } = useFormContext()

  const typeValue = watch('type')
  const commentsValue = watch('comments')
  const charactersLeft = useCharactersLeft(MAX_COMMENTS_LENGTH, commentsValue?.length || 0)

  return (
    <Stack spacing={1.5}>
      <FormSelect name="type" label="Share with" options={shareTypeOptions} />

      {typeValue === ShareType.MEMBERS && (
        <FormMultipleSelect
          name="members"
          label="Team Members"
          options={options}
          defaultValue={[]}
          isLoading={false}
        />
      )}

      <FormInput
        name="comments"
        label="Comments"
        placeholder="Please enter the comments"
        fullWidth
        minRows={3}
        maxRows={6}
        multiline
        helperText={charactersLeft}
        checkTouchField={false}
      />
    </Stack>
  )
}
